import { Component, OnInit } from '@angular/core';
import { Route, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxPermissionsService } from 'ngx-permissions';
import { Subject } from 'rxjs';
import { UserPrivileges, UserRoleConstants } from 'src/app/constants/AppConstants';
import { RoutesConstants } from 'src/app/constants/RoutesConstants';
import { AuthServiceService } from 'src/app/services/auth-service.service';
import { CommonServiceService } from 'src/app/services/common-service.service';
import { RestService } from 'src/app/services/rest.service';

@Component({
  selector: 'app-c-blocked-plots',
  templateUrl: './c-blocked-plots.component.html',
  styleUrls: ['./c-blocked-plots.component.scss']
})
export class CBlockedPlotsComponent implements OnInit {

  dtOptions: any = {};
  dtTrigger: Subject<any> = new Subject<any>();
  companyBlockedPlots: any = [];
  userInfo: any;
  popup = true;
  releasingCompanyBlockedPlot: any;
  closeResult = '';
  error: boolean;
  errorMessage: any;
  ventureId: any;
  userPrivileges = UserPrivileges;


  constructor(
    private restService: RestService,
    public commonService: CommonServiceService,
    private authService: AuthServiceService,
    private modalService: NgbModal,
    private permissionsService: NgxPermissionsService,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.ventureId = this.commonService.getVenture()?.ventureId;

    this.fetchCompanyBlockedPlots();

    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      processing: true,
      bPaginate: false,
      bInfo: false,
      searching: false,
    };
  }


  fetchCompanyBlockedPlots(){

    this.userInfo = this.authService.getUserInfo();

    let url = 'plot/get-company-blocked-plots?ventureId=' + this.ventureId;

  this.dtTrigger.next();
    this.restService.getCompanyBlockedPlots(url).subscribe(response => {
      if (response != null && response != undefined) {
        this.companyBlockedPlots = response.data;

        if (this.authService.hasRole(UserRoleConstants.TENANT)) {
          this.permissionsService.hasPermission(UserPrivileges.TENANT_PRIVILEGE).then(hasTenantPrivilege => {
            if (hasTenantPrivilege) {
              this.popup = false;      
            }
          });
        }

      }
    },
    (error) => {
      console.log(error.status);
    });
  }

  capitalFirst(type) {
    const mySentence = type;
    return mySentence.replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase());
  }

  open(content, plot) {
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
    this.releasingCompanyBlockedPlot = plot;
  }

  private getDismissReason(reason: any): string {

    return `with: ${reason}`;

  }

  openReleaseAlert(releaseContent){

    if (this.companyBlockedPlots && this.companyBlockedPlots.length > 0) {
      this.modalService.open(releaseContent, { ariaLabelledBy: 'modal-basic-title' }).result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
    }

  }



  goToMarkPlotsToCompanyBlocked(){
    this.router.navigate(['/'+this.commonService.getUrlSuffix(), RoutesConstants.VENTURELAYOUT, RoutesConstants.COMPANYBLOCKEDMARKING]);
  }


  releaseCompanyBlockedPlots() {
    const plotIdList = this.companyBlockedPlots.map(plot => plot.plotId);
    
    const requestData = {
        plotIdList: plotIdList
    };

    this.restService.releaseCompanyBlockedPlots(requestData).subscribe(
        (response) => {
            this.modalService.dismissAll();
            this.fetchCompanyBlockedPlots();
        },
        (error) => {
            this.error = true;
            this.errorMessage = error.status;
        }
    );
}

releaseCompanyBlockedPlot(){

    const requestData = {
      plotIdList: [this.releasingCompanyBlockedPlot.plotId]
    };
    this.restService.releaseCompanyBlockedPlots(requestData).subscribe((response) => {
        this.modalService.dismissAll();
        this.fetchCompanyBlockedPlots();
    },
      (error) => {
        this.error = true;
        this.errorMessage = error.status;
      });

  }

}
